import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WarehouseReceiptStatus } from '../enums/warehouse-receipt-status';
import { WarehouseReceiptStatusProviderService } from '../providers/warehouse-receipt-status-provider.service';

@Pipe({
  name: 'warehouseReceiptStatus',
  standalone: true,
})
export class WarehouseReceiptStatusPipe implements PipeTransform {
  private readonly provider = inject(WarehouseReceiptStatusProviderService);

  public transform(status: WarehouseReceiptStatus): Observable<string> {
    return this.provider.label(status);
  }
}
